import classes from "../../purchase.module.scss";
import { dateToLocale, formatMiles, formatMilesDecimalNew } from "@/services/Utils";
import OrdersDeliveryCodes from "./OrdersDeliveryCodes";

const OrdersDeliveryTableBodyDetail = ({ item }) => {
	if (!item.active) {
		return null;
	}

	return (
		<tr className={classes.table_detail}>
			<td colSpan={12} className={classes.td_table}>
				<table className={classes.table_item}>
					<thead>
						<tr className={classes.table_item_tr}>
							<th className={classes.th_detail} style={{ width: "20%" }}>
								Producto
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Cant. Envases
							</th>
							<th className={classes.th_detail} style={{ width: "15%" }}>
								Contenido
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								U.M
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Precio
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Fecha de Vencimiento
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								NC
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Códigos
							</th>
						</tr>
					</thead>

					<tbody>
						{item &&
							item.items.map((product, i) => {
								return (
									<tr key={i} className={`${classes.table_item_tr}`}>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use} ${classes.first_div}`}>
												{product.product_name}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>{formatMiles(product.quantity)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>
												{formatMilesDecimalNew(product.container_content)}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>{product.unit_measurement}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>
												${formatMilesDecimalNew(product.price)}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>
												{product.expiration_date ? dateToLocale(product.expiration_date) : ""}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use}`}>
												{product.orders_return &&
													product.orders_return.map((or, k) => {
														return (
															<span key={k}>
																NC°{" "}
																<a href={`/nota_credito/editar/${or.code}`} target="_blank" rel="noopener noreferrer">
																	{or.code}
																</a>
															</span>
														);
													})}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${item.pending_tags && classes.in_use} ${classes.last_div}`}>
												<OrdersDeliveryCodes product={product} />
											</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default OrdersDeliveryTableBodyDetail;
